import { createMuiTheme } from '@material-ui/core/styles'
import { fontTypes as gloriolaSTDFont } from '~/assets/fonts/gloriola-std/gloriola-std.exports'

const palette = {
  inverse: false,
  background: {
    paper: '#F5F5F5',
    default: '#ffffff'
  },
  // Custom pallete customized for brand
  primary: {
    main: '#1074AB'
  },
  secondary: {
    main: '#3D9459'
  },
  error: {
    main: '#DE1616'
  },
  warning: {
    main: '#FF9700'
  },
  info: {
    main: '#1074AB'
  },
  success: {
    main: '#23B218'
  },
  'status-alert': {
    main: '#FBC679'
  },
  // Extra pallete customized for brand
  'brand-primary': {
    main: '#1074AB'
  },
  'brand-secondary': {
    main: '#3D9459'
  },
  'brand-tertiary': {
    main: '#EE3D96'
  },
  'neutral-ultra-dark': {
    main: '#000000'
  },
  'neutral-dark': {
    main: '#515151'
  },
  'neutral-medium': {
    main: '#878787'
  },
  'neutral-light': {
    main: '#F5F5F5'
  },
  'neutral-ultra-light': {
    main: '#FFFFFF'
  },
  'action-conversion-static': {
    light: '#8DC63F',
    main: '#8DC63F',
    dark: '#3D9459'
  },
  'action-conversion-hover': {
    main: '#3D9459'
  },
  'action-conversion-disabled': {
    main: '#D6D6D6'
  },
  'action-navigation-static': {
    light: '#1074AB',
    main: '#1074AB',
    dark: '#BE1B87'
  },
  'action-navigation-hover': {
    main: '#1074AB'
  },
  'action-navigation-disabled': {
    main: '#D6D6D6'
  },
  'action-contrast-static': {
    main: '#FFFFFF',
    contrastText: '#515151'
  },
  'action-contrast-hover': {
    main: '#2DD1FF'
  },
  'action-contrast-disabled': {
    main: '#ffffff3d',
    contrastText: '#D6D6D6'
  },
  // Suport pallete
  'support-whatsapp': {
    main: '#128C7E'
  },
  'support-facebook': {
    main: '#3B5998'
  },
  'support-BOT': {
    main: '#6F967E',
    text: '#ffffff',
    name: 'Boticário'
  },
  'support-EUD': {
    main: '#472D75',
    text: '#ffffff',
    name: 'Eudora'
  },
  'support-QDB': {
    main: '#DB5958',
    text: '#ffffff',
    name: 'Quem Disse Berenice'
  },
  'support-BLZ': {
    main: '#6A1B60',
    text: '#ffffff',
    name: 'Beleza na Web'
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
  date: {
    color: '#1074AB',
    name: 'azul'
  }
}

export default createMuiTheme({
  palette,
  spacing: (i) => (i < 5 ? i * 4 : ((i - 2) * 8)),
  breakpoints: {
    values: {
      xs: 0,
      sm: 425,
      md: 1024,
      lg: 1440,
      xl: 1920,
      mobile: 425,
      tablet: 1024,
      desktop: 1440
    }
  },
  typography: {
    fontFamily: [
      '"Gloriola STD"',
      'Roboto',
      'Arial',
      'sans-serif'
    ].join(', '),
    fontWeight: 400,
    fontStyle: 'normal',
    h1: {
      fontSize: 96,
      lineHeight: '104px',
      fontWeight: 600
    },
    h2: {
      fontSize: 72,
      lineHeight: '80px',
      fontWeight: 600
    },
    h3: {
      fontSize: 56,
      lineHeight: '64px',
      fontWeight: 600
    },
    h4: {
      fontSize: 40,
      lineHeight: '48px',
      fontWeight: 600
    },
    h5: {
      fontSize: 32,
      lineHeight: '40px'
    },
    h6: {
      fontSize: 24,
      lineHeight: '32px'
    },
    body1: {
      fontSize: 16,
      lineHeight: '24px'
    },
    body2: {
      fontSize: 14,
      lineHeight: '24px'
    },
    subtitle1: {
      fontSize: 16,
      lineHeight: '20px'
    },
    subtitle2: {
      fontSize: 14,
      lineHeight: '16px'
    },
    caption: {
      fontSize: 12,
      lineHeight: '16px'
    },
    overline: {
      fontSize: 10,
      lineHeight: '16px',
      textTransform: 'uppercase',
      letterSpacing: '0.08em'
    }
  },
  overrides: {
    MuiDrawer: {
      paper: {
        width: 360,
        backgroundColor: palette['neutral-light'].main
      },
      paperAnchorDockedLeft: {
        position: 'relative'
      }
    },
    MuiButton: {
      root: {
        borderRadius: 4,
        height: 48
      },
      contained: {
        width: '100%',
        boxShadow: 'none'
      },
      sizeSmall: {
        height: 32
      },
      sizeLarge: {
        height: 64
      }
    },
    MuiDivider: {
      light: {
        backgroundColor: palette['neutral-ultra-light'].main
      }
    },
    MuiTableCell: {
      head: {
        fontStyle: 'normal',
        fontSize: 10,
        lineHeight: '16px',
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        fontWeight: 600
      },
      body: {
        fontStyle: 'normal',
        fontSize: 14,
        lineHeight: '24px',
        fontWeight: 400
      }
    },
    MuiListItem: {
      root: {
        paddingTop: 10,
        paddingBottom: 10,
        '&$selected': {
          backgroundColor: palette['neutral-dark'].main,
          color: palette['neutral-ultra-light'].main,
          '&:hover': {
            backgroundColor: '#5f5d5d'
          },
          '& .MuiListItemIcon-root': {
            color: palette['neutral-ultra-light'].main
          }
        }
      }
    },
    MuiRadio: {
      root: {
        '& .MuiSvgIcon-root': {
          fontSize: '1rem'
        }
      }
    },
    MuiTextField: {
      root: {
        backgroundColor: palette['neutral-ultra-light'].main
      }
    },
    MuiInputBase: {
      root: {
        transition: 'all 0.3s ease-in-out',
        '&.Mui-focused': {
          boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.32)'
        }
      },
      input: {
        '&:-webkit-autofill': {
          '-webkitBackgroundClip': 'text'
        }
      }
    },
    MuiOutlinedInput: {
      input: {
        padding: '0 12px',
        minHeight: 48
      }
    },
    MuiFormHelperText: {
      root: {
        textTransform: 'normal'
      }
    },
    MuiSelect: {
      selectMenu: {
        padding: '0 14px',
        minHeight: 48
      },
      select: {
        display: 'flex',
        alignItems: 'center'
      }
    },
    MuiFormLabel: {
      root: {
        lineHeight: '7px'
      }
    },
    MuiListItemIcon: {
      root: {
        justifyContent: 'center',
        minWidth: 40
      }
    },
    MuiListItemAvatar: {
      root: {
        minWidth: 32
      }
    },
    MuiAvatar: {
      square: {
        width: 24,
        height: 24
      }
    },
    MuiAlert: {
      standardError: {
        backgroundColor: 'transparent',
        paddingLeft: 0,
        paddingRight: 0,
        color: palette.error.main
      },
      filledSuccess: {
        backgroundColor: palette.secondary.main
      }
    },
    MuiTabs: {
      root: {
        minHeight: 32,
        borderBottom: palette['neutral-medium'].main,
        '& .MuiTabScrollButton-root': {
          width: 24
        },
        '& .MuiTab-root': {
          minWidth: 'initial',
          minHeight: 32,
          padding: '0 16px 4px'
        },
        '& .MuiTabs-indicator': {
          height: 4
        }
      }
    },
    MuiPaper: {
      root: {
        '&.MuiPaper-elevation1': {
          boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.15)'
        }
      }
    },
    MuiPickersBasePicker: {
      container: {
        alignItems: 'center'
      }
    },
    MuiPopover: {
      root: {
        zIndex: '999999 !important',
        '& .MuiMenuItem-root': {
          minHeight: '48px !important'
        },
        '& .MuiListItem-root.Mui-selected': {
          backgroundColor: 'transparent',
          color: '#8DC63F',
          paddingLeft: 24
        }
      }
    },
    MuiTooltip: {
      tooltip: {
        color: '#ffffff',
        background: 'linear-gradient(77.73deg, #8DC63F 0%, #3D9459 100%)',
        fontStyle: 'normal',
        fontSize: 12,
        lineHeight: '16px',
        fontWeight: 400,
        padding: 16
      },
      arrow: {
        color: '#6BB14A'
      }
    },
    MuiCssBaseline: {
      '@global': {
        a: {
          color: palette['action-conversion-static'].main,
          '&:hover': {
            color: palette['action-conversion-hover'].main
          }
        },
        '@font-face': gloriolaSTDFont,
        '*::-webkit-scrollbar': {
          width: '0.4em'
        },
        '*::-webkit-scrollbar-track': {
          '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0,0,0,.4)',
          outline: '1px solid slategrey',
          borderRadius: 3
        }
      }
    }
  }
})
